// src/graphql/queries/featureQueries.js

export const getFeatureCatalog = () => `query GetFeatureCatalog {
    featureCatalog {
        id
        name
        description
        minTier
        module
    }
}`;

export const getCompanyFeatureOverrides = () => `query GetCompanyFeatureOverrides($companyId: String!) {
    companyFeatureOverrides(companyId: $companyId) {
        id
        companyId
        featureId
        enabled
        reason
        createdBy
        createdAt
        updatedAt
    }
}`;

export const getAllFeatureOverrides = () => `query GetAllFeatureOverrides {
    allFeatureOverrides {
        id
        companyId
        featureId
        enabled
        reason
        createdBy
        createdAt
    }
}`;
